import { useMemo, useState } from "react";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import {
  ArrowDown01Icon,
  ArrowUp01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { DocumentCard } from "views/applications-id-report/slices/IncomeReportSlice/components/DocumentCard";
import { VerifiedBankStatement } from "../../../types/verified/bank-statment";
import { getBankStatementReasonCodes } from "../../TablesSlice/components/BankStatementTable/utils";

export const BankStatementWarning = ({
  bankStatement
}: {
  bankStatement: VerifiedBankStatement;
}) => {
  const [expanded, setExpanded] = useState(false);

  const asset = bankStatement.asset,
    trustScore = bankStatement.raw_data?.trust_score;
  const reasonCodes = useMemo(() => {
    return getBankStatementReasonCodes(bankStatement);
  }, [bankStatement]);

  return (
    <>
      <div className="flex w-full justify-between flex-wrap md:flex-nowrap gap-y-2 items-start">
        <div className="flex items-center gap-3">
          <HugeiconsIcon
            icon={AlertCircleIcon}
            size={20}
            className="text-warning-500"
          />
          <div className="flex flex-col gap-1 items-start">
            <p className="text-content-1000 font-medium mr-2">
              Uploaded bank statement didn&apos;t have any selected income
              deposits
            </p>
            {asset?.asset?.filename && (
              <p className="text-content-400 font-normal text-sm">
                {asset.asset.filename}
              </p>
            )}
          </div>
        </div>

        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          onClick={() => setExpanded(!expanded)}
        >
          <div className="flex items-center gap-1">
            <HugeiconsIcon
              icon={expanded ? ArrowUp01Icon : ArrowDown01Icon}
              className="-ml-1"
            />
            <span>{expanded ? "Hide" : "Show"} Details</span>
          </div>
        </Button>
      </div>

      <Show if={expanded}>
        <div className="p-6 bg-background-900 border-t border-alpha-100">
          <DocumentCard
            score={trustScore || 0}
            asset={asset?.asset}
            reasonCodes={reasonCodes}
            ignorePrint
          />
        </div>
      </Show>
    </>
  );
};
